import { useColorModeValue } from "@/components/ui/color-mode"
import { Box, Image } from "@chakra-ui/react"
import PalommaLogoSmall from "../assets/PalommaLogoSmall.jpg"
import PalommaLogoWhite from "../assets/PalommaLogoWhite.svg"
import PalommaLogoWithText from "../assets/PalommaLogoWithText.svg"

export const Logo = ({ showText = true }: { showText?: boolean }) => {
  const logoSrc = useColorModeValue(
    showText ? PalommaLogoWithText : PalommaLogoSmall,
    showText ? PalommaLogoWhite : PalommaLogoSmall
  )

  return (
    <Box
      height="60px"
      display="flex"
      alignItems="center"
      justifyContent={showText ? "flex-start" : "center"}
      transition="all 0.3s"
    >
      <Image
        src={logoSrc}
        alt="Palomma"
        height={showText ? "32px" : "32px"}
        objectFit="contain"
        borderRadius={showText ? "0" : "md"}
        transition="all 0.3s"
      />
    </Box>
  )
}
